import React from 'react';
import { Tooltip } from 'react-tooltip';

import { stateTypes } from '@constants/aiStates';
import { URGENCY_TOOLTIPS } from '@constants/urgencyTooltips';

import useTranslation from '@hooks/useTranslation';

import type { ITooltipData } from './model/statusItem';
import style from './style.module.scss';

interface IProps {
  id: string;
}

const TooltipStatus: React.FC<IProps> = ({ id }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      id={id}
      className={style.statusTooltip}
      render={({ content }) => {
        if (!content) {
          return null;
        }
        const item = JSON.parse(content) as ITooltipData;

        const tooltipTitle = stateTypes[item.stateName] || '';
        const tooltipText = URGENCY_TOOLTIPS[item.urgencyName] || '';

        return (
          <>
            {t(tooltipTitle)}
            {item.stateName !== 'Snoozed' ? <div>{t(tooltipText)}</div> : <span>{item.snoozeDateTime}</span>}
          </>
        );
      }}
    />
  );
};

export default TooltipStatus;
